import { render } from "./MessagePicture.vue?vue&type=template&id=6c63f804&scoped=true"
import script from "./MessagePicture.vue?vue&type=script&lang=js"
export * from "./MessagePicture.vue?vue&type=script&lang=js"

import "./MessagePicture.vue?vue&type=style&index=0&id=6c63f804&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c63f804"]])

export default __exports__